import {
  Button,
  Checkbox,
  Flex,
  Form,
  FormInstance,
  InputNumber,
  message,
  Modal,
  Space,
  Table,
  Tooltip,
  Typography,
} from "antd";
import { ApiService } from "api/api.service";
import PageTitle from "components/PageTitle";
import { loaderSm, SingleQueryWrapper } from "components/QueryWrapper";
import { T_Populate, T_QueryData } from "types/_utils.types";
import DashboardLayout from "layout/DashboardLayout";
import {
  TbAlertTriangleFilled,
  TbCircleCheckFilled,
  TbExclamationCircleFilled,
  TbMinus,
  TbPlayerPlayFilled,
  TbPlus,
  TbX,
} from "react-icons/tb";
import { useParams, useSearchParams } from "react-router-dom";
import { formatMoney } from "utils/functions";
import styles from "./LoanIntelligence.module.scss";
import { CreditorSplitFormat, PaymentEntryTable } from "dtos/application.dto";
import { ReactNode, useEffect, useState } from "react";
import { detailedLedgerColumns, detailedLedgerColumnsForPreview } from "./Calculator.utils";
import { NegotiationStatus } from "store/loanIntelligence";
import { queryClient } from "utils/queryClient";
import { CalculatorValidationCodes } from "api/application.service";
import { storedTokens } from "utils/storedTokens";
import ExternalCalculatorLayout from "layout/ExternalCalculatorLayout/ExternalCalculatorLayout";
import { LEDGER_CATEGORY, LedgerSchemaDto } from "dtos/ledger.dto";
import { set } from "zod";
import { FileSchemaDto } from "dtos/file.dto";
import { LoanSchemaDto } from "dtos/loan.dto";

export default function CalculatorExecute({
  Layout = DashboardLayout,
  // externalToken,
}: {
  Layout?: (props: { children?: ReactNode; headerLeft?: ReactNode; headerRight?: ReactNode }) => JSX.Element;
  externalToken?: string;
}) {
  const appKey = useParams()?.appKey;
  const fullApplication = ApiService.application.useGetByAppKey(appKey, "loanIntelligence");
  const applicationId = fullApplication?.data?.application?._id;
  const getclearApp = fullApplication?.data?.data?.application;
  const calcSuggestion = ApiService.application.useGetCalculatorExecuteSuggestion(appKey);
  const getSavedCalculatorExecute = ApiService.application.useGetCalculatorExecuteSaved(appKey);
  const modifyRowsCount = ApiService.ledger.useModifyRows();
  const [formValues, setFormValues] = useState<T_FormValues>({});

  const [isAddRowModalOpen, setIsAddRowModalOpen] = useState(false);
  const [isPaymentLedgerOpen, setIsPaymentLedgerOpen] = useState(false);
  const [previewLedgerOpen, setPreviewLedgerOpen] = useState(false);
  const [showManual, setShowManual] = useState(false);
  const [isExecutebtnClicked, setIsExecuteBtnClicked] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  return (
    <Layout
      headerRight={
        applicationId ? (
          <div className="flex gap-2">
            <Button
              loading={modifyRowsCount.isPending}
              onClick={() => {
                // setIsAddRowModalOpen(true);
                modifyRowsCount.mutate(
                  { application_id: applicationId, count: 0 },
                  {
                    onSuccess: () => {
                      message.success("Empty rows removed");
                    },
                  },
                );
              }}
            >
              Remove Empty Rows
            </Button>
            <Button
              // variant="solid"
              // color="green"
              // className="!bg-green-600"
              onClick={() => {
                setShowManual(!showManual);
              }}
            >
              {showManual ? "Hide" : "Show"} Manual
            </Button>
            <Button
              onClick={() => {
                setIsExecuteBtnClicked(false);
                setPreviewLedgerOpen(true);
              }}
            >
              {/**Ledger will be previewed from saved data  */}
              Preview Ledger
            </Button>
            <Button
              onClick={() => {
                setIsPaymentLedgerOpen(true);
              }}
            >
              Payment Ledger
            </Button>
          </div>
        ) : null
      }
    >
      <PageTitle
        title="Calculator Execute"
        pageTitle={[
          { title: `Applications`, link: "/dashboard/applications" },
          {
            title: getclearApp?.client_details?.name ?? "Application Item",
            link: `/dashboard/application/${getclearApp?.app_key}`,
          },
          { title: "Calculator", link: `/dashboard/application/${getclearApp?.app_key}/calculator` },
          { title: "Execute" },
        ]}
      />
      <SingleQueryWrapper
        query={fullApplication}
        renderData={(application) => {
          return (
            <SingleQueryWrapper
              query={getSavedCalculatorExecute}
              renderData={(savedData) => {
                return (
                  <SingleQueryWrapper
                    query={calcSuggestion}
                    renderData={(suggestion) => {
                      return (
                        <SimpleCalculatorExecuteInternal
                          application={application}
                          suggestion={suggestion?.result}
                          savedData={savedData?.result}
                          showManual={showManual}
                          setShowManual={setShowManual}
                          setPreviewLedgerOpen={(val) => setPreviewLedgerOpen(val)}
                          isChecked={isChecked}
                          isExecuteBtnCLicked={isExecutebtnClicked}
                          setIsChecked={(val) => setIsChecked(val)}
                          setIsExecuteBtnClicked={(val) => setIsExecuteBtnClicked(val)}
                          setFormVales={(val) => {
                            setFormValues(val);
                          }}
                        />
                      );
                    }}
                  />
                );
              }}
            />
          );
        }}
      />
      {applicationId ? (
        <RemoveRowsModalContent
          open={isAddRowModalOpen}
          onClose={() => {
            setIsAddRowModalOpen(false);
          }}
          applicationId={applicationId}
        />
      ) : null}
      {applicationId && isPaymentLedgerOpen ? (
        <PaymentLedgerModal
          open={isPaymentLedgerOpen}
          onClose={() => {
            setIsPaymentLedgerOpen(false);
          }}
          applicationId={applicationId}
          loans={fullApplication?.data?.data?.application?.loans}
        />
      ) : null}
      {applicationId && previewLedgerOpen ? (
        <PreviewLedgerModal
          open={previewLedgerOpen}
          onClose={() => {
            setPreviewLedgerOpen(false);
          }}
          applicationId={applicationId}
          fullApplication={fullApplication}
          formValues={formValues}
          isExtecuteBtnClicked={isExecutebtnClicked}
          setIsExecuteBtnClicked={(val) => setIsExecuteBtnClicked(val)}
          isChecked={isChecked}
          setIsChecked={(val) => setIsChecked(val)}
        />
      ) : null}
    </Layout>
  );
}

export function ExternalCalculatorExecute() {
  const [searchParams] = useSearchParams();
  const token = searchParams?.get("token");

  useEffect(() => {
    if (token) {
      storedTokens.accessToken.setToken(token);
    }
  }, [token]);

  return <CalculatorExecute Layout={ExternalCalculatorLayout} externalToken={token ?? undefined} />;
}

export function PaymentLedgerModal({
  open,
  onClose,
  applicationId,
  loans,
}: Readonly<{
  open: boolean;
  onClose: () => void;
  applicationId: string;
  loans: T_Populate<LoanSchemaDto, { attachments: FileSchemaDto[] }>[] | undefined;
}>) {
  const [cycle, setCycle] = useState<"weekly" | "monthly">("weekly");
  const paymentTable = ApiService.application.useGetPaymentTable(applicationId);

  const isMonthlyAvailable = (payment_table: LedgerSchemaDto[]) =>
    payment_table?.some((entry) => entry.category === LEDGER_CATEGORY.MONTHLY) ? "monthly" : "weekly";

  useEffect(() => {
    if (paymentTable.data?.payment_table.length) setCycle(() => isMonthlyAvailable(paymentTable.data?.payment_table));
  }, [paymentTable.data?.payment_table]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={1200}
      title={
        <Flex className="gap-3 justify-between">
          <Typography.Title level={5}>Payment Ledger</Typography.Title>
          {<Button></Button>}
        </Flex>
      }
      footer={null}
    >
      <Table
        size="small"
        virtual
        scroll={{ y: 400, x: 1100 }}
        rowKey={"_id"}
        loading={{ spinning: paymentTable.isFetching, indicator: loaderSm }}
        columns={detailedLedgerColumns(loans, cycle)}
        dataSource={paymentTable.data?.payment_table}
        rowClassName={(rec) => (rec.category === LEDGER_CATEGORY.SKIP ? "opacity-70" : "bg-indigo-50")}
        bordered
        summary={() => (
          <Table.Summary fixed={"bottom"}>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} className="bg-gray-100 font-bold text-gray-800">
                Total
              </Table.Summary.Cell>
              <Table.Summary.Cell index={1} align="right" className="bg-gray-100 font-bold text-gray-800">
                {paymentTable.data?.payment_table
                  ? formatMoney(paymentTable.data?.payment_table?.reduce((prev, curr) => prev + (curr?.amount ?? 0), 0))
                  : "-"}
              </Table.Summary.Cell>
              <Table.Summary.Cell index={2} align="right" className="bg-gray-100 font-bold text-gray-800">
                {paymentTable.data?.payment_table
                  ? formatMoney(
                      paymentTable.data?.payment_table?.reduce(
                        (prev, curr) => prev + (curr?.distribution?.program_fee ?? 0),
                        0,
                      ),
                    )
                  : "-"}
              </Table.Summary.Cell>
              <Table.Summary.Cell index={3} align="right" className="bg-gray-100 font-bold text-gray-800">
                {paymentTable.data?.payment_table
                  ? formatMoney(
                      paymentTable.data?.payment_table?.reduce(
                        (prev, curr) => prev + (curr?.distribution?.service_fee ?? 0),
                        0,
                      ),
                    )
                  : "-"}
              </Table.Summary.Cell>
              <Table.Summary.Cell index={4} align="right" className="bg-gray-100 font-bold text-gray-800">
                {paymentTable.data?.payment_table
                  ? formatMoney(
                      paymentTable.data?.payment_table?.reduce(
                        (prev, curr) => prev + (curr?.distribution?.legal_fee ?? 0),
                        0,
                      ),
                    )
                  : "-"}
              </Table.Summary.Cell>
              <Table.Summary.Cell index={5} align="right" className="bg-gray-100 font-bold text-gray-800">
                {paymentTable.data?.payment_table
                  ? formatMoney(
                      paymentTable.data?.payment_table?.reduce(
                        (prev, curr) => prev + (curr?.distribution?.creditor_total ?? 0),
                        0,
                      ),
                    )
                  : "-"}
              </Table.Summary.Cell>
            </Table.Summary.Row>
          </Table.Summary>
        )}
        pagination={false}
        sticky={{ offsetHeader: 64 }}
      />
    </Modal>
  );
}
type Output = { creditor_id: string; amount: number | null }[][];
function PreviewLedgerModal({
  open,
  onClose,
  applicationId,
  fullApplication,
  formValues,
  isExtecuteBtnClicked,
  setIsExecuteBtnClicked,
  isChecked,
  setIsChecked,
}: {
  open: boolean;
  onClose: () => void;
  applicationId: string;
  fullApplication: ReturnType<typeof ApiService.application.useGetByAppKey>;
  formValues: T_FormValues;
  isExtecuteBtnClicked: boolean;
  setIsExecuteBtnClicked: (val: boolean) => void;
  isChecked: boolean;
  setIsChecked: (val: boolean) => void;
  // previewLedgerData: any;
}) {
  const paymentTable = ApiService.application.useGetPaymentTable(applicationId);
  // console.log("Form values inside  preview modal", formValues);

  const totalWeeks = paymentTable.data?.payment_table?.length;

  function convertToWeeklyStructure(data: T_FormValues, totalWeeks: number): Output {
    // Step 1: Prepare result array of size totalWeeks
    const result: Output = Array.from({ length: totalWeeks }, () => []);

    // Step 2: Process each creditor
    for (const [creditor_id, chunks] of Object.entries(data)) {
      // Flatten the chunks into a single array
      const flat = chunks.flat().filter((e) => e.amount !== undefined && e.weeks !== undefined);

      // Build an array of weekly values for this creditor
      const creditorWeeks: (number | null)[] = [];
      for (const { amount, weeks } of flat) {
        for (let i = 0; i < (weeks ?? 0); i++) {
          creditorWeeks.push(amount ?? null);
        }
      }

      // Fill remaining weeks with null until totalWeeks
      while (creditorWeeks.length < totalWeeks) {
        creditorWeeks.push(null);
      }

      // Step 3: Merge creditor values into result
      for (let week = 0; week < totalWeeks; week++) {
        result[week].push({
          creditor_id,
          amount: creditorWeeks[week],
        });
      }
    }

    return result;
  }
  useEffect(() => {
    const structuredData = convertToWeeklyStructure(formValues, totalWeeks ?? 0);
    // console.log("Structured Data", structuredData);
    // console.log(formatPaymentTable(structuredData));
  }, [formValues, totalWeeks]);

  const formatPaymentTable = (data: Output) => {
    return paymentTable.data?.payment_table?.map((row, index) => {
      if (index === 0) {
        return row;
      }

      return {
        ...row,
        creditors: data[index - 1]?.map((el) => ({
          creditor_id: el.creditor_id,
          amount: el.amount,
        })),
      };
    });
  };

  return (
    <Modal
      open={open}
      onCancel={() => {
        onClose();
      }}
      width={1200}
      title={
        <div className="flex justify-between gap-3 pr-8">
          <Typography.Title level={5}>Preview Ledger</Typography.Title>
          {isExtecuteBtnClicked && (
            <div className="flex items-center gap-1">
              <Checkbox checked={isChecked} onChange={() => setIsChecked(!isChecked)} />
              <Typography.Text type="secondary">I have checked the mock ledger</Typography.Text>
            </div>
          )}
        </div>
      }
      footer={null}
    >
      <Table
        size="small"
        virtual
        scroll={{ y: 400, x: 1100 }}
        rowKey={"_id"}
        loading={{ spinning: paymentTable.isFetching, indicator: loaderSm }}
        columns={detailedLedgerColumnsForPreview(fullApplication?.data?.data?.application?.loans) as any}
        //nedd o change the last three colomnvalue here
        dataSource={formatPaymentTable(convertToWeeklyStructure(formValues, totalWeeks ?? 0))}
        bordered
        summary={() => (
          <Table.Summary fixed={"bottom"}>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} className="bg-gray-100 font-bold text-gray-800">
                Total
              </Table.Summary.Cell>
              <Table.Summary.Cell index={1} align="right" className="bg-gray-100 font-bold text-gray-800">
                {paymentTable.data?.payment_table
                  ? formatMoney(paymentTable.data?.payment_table?.reduce((prev, curr) => prev + (curr?.amount ?? 0), 0))
                  : "-"}
              </Table.Summary.Cell>
              <Table.Summary.Cell index={2} align="right" className="bg-gray-100 font-bold text-gray-800">
                {paymentTable.data?.payment_table
                  ? formatMoney(
                      paymentTable.data?.payment_table?.reduce(
                        (prev, curr) => prev + (curr?.distribution?.program_fee ?? 0),
                        0,
                      ),
                    )
                  : "-"}
              </Table.Summary.Cell>
              <Table.Summary.Cell index={3} align="right" className="bg-gray-100 font-bold text-gray-800">
                {paymentTable.data?.payment_table
                  ? formatMoney(
                      paymentTable.data?.payment_table?.reduce(
                        (prev, curr) => prev + (curr?.distribution?.service_fee ?? 0),
                        0,
                      ),
                    )
                  : "-"}
              </Table.Summary.Cell>
              <Table.Summary.Cell index={4} align="right" className="bg-gray-100 font-bold text-gray-800">
                {paymentTable.data?.payment_table
                  ? formatMoney(
                      paymentTable.data?.payment_table?.reduce(
                        (prev, curr) => prev + (curr?.distribution?.legal_fee ?? 0),
                        0,
                      ),
                    )
                  : "-"}
              </Table.Summary.Cell>
              <Table.Summary.Cell index={5} align="right" className="bg-gray-100 font-bold text-gray-800">
                {paymentTable.data?.payment_table
                  ? formatMoney(
                      paymentTable.data?.payment_table?.reduce(
                        (prev, curr) => prev + (curr?.distribution?.creditor_total ?? 0),
                        0,
                      ),
                    )
                  : "-"}
              </Table.Summary.Cell>
            </Table.Summary.Row>
          </Table.Summary>
        )}
        pagination={false}
        sticky={{ offsetHeader: 64 }}
      />
    </Modal>
  );
}

function RemoveRowsModalContent({
  open,
  onClose,
  applicationId,
}: {
  open: boolean;
  onClose: () => void;
  applicationId: string;
}) {
  const [count, setCount] = useState(1);
  const modifyRowsCount = ApiService.ledger.useModifyRows();

  return (
    <Modal
      open={open}
      title="Remove empty rows"
      onCancel={() => {
        onClose();
      }}
      okText="Confirm"
      okButtonProps={{
        loading: modifyRowsCount.isPending,
        onClick: () => {
          modifyRowsCount.mutate(
            {
              application_id: applicationId,
              count: -count,
            },
            {
              onSuccess: () => {
                message.success("Rows removed");
                onClose();
              },
            },
          );
        },
      }}
    >
      <div className="flex gap-3 justify-center items-center">
        <Space.Compact>
          <Button
            size="large"
            icon={<TbMinus />}
            onClick={() => {
              if (count > 1) {
                setCount(count - 1);
              }
            }}
          />
          <InputNumber
            size="large"
            value={count}
            min={1}
            onChange={(val) => {
              if (val) {
                setCount(val);
              } else {
                setCount(1);
              }
            }}
            className="!font-black !text-2xl [&_input]:!text-center"
          />
          <Button
            size="large"
            icon={<TbPlus />}
            onClick={() => {
              setCount(count + 1);
            }}
          />
        </Space.Compact>
      </div>
    </Modal>
  );
}

export type T_FormValues = Record<string, { amount: number | undefined; weeks: number | undefined }[][]>;
type T_Suggestion = T_QueryData<typeof ApiService.application.useGetCalculatorExecuteSuggestion>["result"];

function getFormInitialValue({
  latestPaymentTable,
  loanIntelligence,
  savedData,
  suggestion,
}: {
  latestPaymentTable: any;
  loanIntelligence: any;
  savedData: any;
  suggestion: any;
}) {
  // console.log("yo", savedData, suggestion?.suggestion, savedData ?? suggestion?.suggestion);

  const obj: T_FormValues = {};
  if (!latestPaymentTable?.repeat_rows) {
    return obj;
  }
  const repeatRowsMap: { start_week: number; end_week: number; amount: number }[] = [];
  let lastWeek = 0;
  latestPaymentTable?.repeat_rows?.forEach((repeatRow: any, i: any) => {
    const endWeek = lastWeek + repeatRow.count;
    repeatRowsMap[i] = { start_week: lastWeek + 1, end_week: endWeek, amount: repeatRow.row.payment };
    lastWeek = endWeek;
  });

  Object.keys(loanIntelligence?.loans?.current).forEach((loanId) => {
    const item: { amount: number; weeks: number }[][] = [];
    repeatRowsMap?.forEach((repeatRow) => {
      const matched: { amount: number; weeks: number }[] = [];
      (savedData ?? suggestion?.suggestion)?.[loanId]?.forEach((sug: any) => {
        if (sug.start_week >= repeatRow.start_week && sug.end_week <= repeatRow.end_week) {
          matched.push({ amount: Number(sug.amount.toFixed(2)), weeks: sug.end_week - sug.start_week + 1 });
        } else if (sug.start_week >= repeatRow.start_week && sug.start_week <= repeatRow.end_week) {
          matched.push({ amount: Number(sug.amount.toFixed(2)), weeks: repeatRow.end_week - sug.start_week + 1 });
        } else if (sug.end_week >= repeatRow.start_week && sug.end_week <= repeatRow.end_week) {
          matched.push({ amount: Number(sug.amount.toFixed(2)), weeks: sug.end_week - repeatRow.start_week + 1 });
        } else if (sug.start_week < repeatRow.start_week && sug.end_week > repeatRow.end_week) {
          matched.push({
            amount: Number(sug.amount.toFixed(2)),
            weeks: repeatRow.end_week - repeatRow.start_week + 1,
          });
        }
      });

      item.push(matched);
    });
    obj[loanId] = item;
  });
  // console.log("obj", obj);

  return obj;
}

function SimpleCalculatorExecuteInternal({
  application,
  suggestion,
  savedData,
  showManual,
  setShowManual,
  setFormVales,
  setPreviewLedgerOpen,
  isChecked,
  isExecuteBtnCLicked,
  setIsChecked,
  setIsExecuteBtnClicked,
}: {
  application: T_QueryData<typeof ApiService.application.useGetByAppKey>;
  suggestion: T_Suggestion;
  savedData: CreditorSplitFormat | undefined | null;
  showManual: boolean;
  setShowManual: (val: boolean) => void;
  setFormVales: (val: T_FormValues) => void;
  setPreviewLedgerOpen: (val: boolean) => void;
  isChecked: boolean;
  setIsChecked: (val: boolean) => void;
  isExecuteBtnCLicked: boolean;
  setIsExecuteBtnClicked: (val: boolean) => void;
}) {
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState<{ state: boolean; count: number; loanId?: string }>({
    state: false,
    count: 0,
  });
  const validateCalculatorExecute = ApiService.application.useValidateCalculator(application.application.app_key);
  const saveCalculatorExecute = ApiService.application.useSaveCalculatorSave(application.application.app_key);
  const executeCalculatorExecute = ApiService.application.useSaveCalculatorExecute(application.application.app_key);
  // const [formvalues, setFormVales] = useState<T_FormValues>({});

  const getclearApp = application?.data?.application;
  const latestPaymentTable =
    application?.application?.payment_table?.[application?.application?.payment_table?.length - 1];
  const loanIntelligence = application?.application?.loan_intelligence;
  const currentLoans = loanIntelligence ? Object.values(loanIntelligence?.loans?.current) : undefined;
  const totalDebt = getclearApp?.summary?.current_debt;

  const [form] = Form.useForm<T_FormValues>();
  const formValues = Form.useWatch([], form);
  const splitTotal = formValues
    ? Object.values(formValues)
        .flat()
        .flat()
        .reduce((prev, curr) => prev + (curr?.amount ?? 0) * (curr?.weeks ?? 0), 0)
    : 0;
  const totalRemaining = totalDebt - splitTotal;

  const autoCalculate = ApiService.application.useCalculatorCreditorAutoCalculate(application.application.app_key);
  const modifyNumberOfRows = ApiService.ledger.useModifyRows();

  // console.log("savedData", savedData);

  useEffect(() => {
    if (savedData) {
      form.setFieldsValue(getFormInitialValue({ latestPaymentTable, loanIntelligence, savedData, suggestion }));
    }
  }, [savedData]);
  useEffect(() => {
    setFormVales(formValues);
  }, []);

  useEffect(() => {
    setFormVales(formValues);
  }, [formValues]);
  // validate
  const validate = async () => {
    try {
      const values = await form.validateFields();

      const creditorSplit: CreditorSplitFormat = {};
      Object.entries(values)?.map(([loanId, split]) => {
        let lastEnd = 1;
        creditorSplit[loanId] = split
          .flat()
          .map((item) => {
            if (item?.amount && item?.weeks) {
              const start = lastEnd;
              lastEnd = item?.weeks + lastEnd;
              return { start_week: start, end_week: lastEnd - 1, amount: item?.amount };
            }
            return undefined;
          })
          ?.filter((el) => el !== undefined);
      });

      validateCalculatorExecute.mutate(creditorSplit);
    } catch (error) {
      console.log(error);
    }
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      setFormVales(values);

      // console.log({ values });

      const creditorSplit: CreditorSplitFormat = {};
      Object.entries(values)?.map(([loanId, split]) => {
        let lastEnd = 1;
        creditorSplit[loanId] = split
          .flat()
          .map((item) => {
            if (item?.amount && item?.weeks) {
              const start = lastEnd;
              lastEnd = item?.weeks + lastEnd;
              return { start_week: start, end_week: lastEnd - 1, amount: item?.amount };
            }
            return undefined;
          })
          ?.filter((el) => el !== undefined);
      });

      saveCalculatorExecute.mutate(creditorSplit, {
        onSuccess: () => {
          message.success("Saved successfully");
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const execute = async () => {
    try {
      const values = await form.validateFields();

      const creditorSplit: CreditorSplitFormat = {};
      Object.entries(values)?.map(([loanId, split]) => {
        let lastEnd = 1;
        creditorSplit[loanId] = split
          .flat()
          .map((item) => {
            if (item?.amount && item?.weeks) {
              const start = lastEnd;
              lastEnd = item?.weeks + lastEnd;
              return { start_week: start, end_week: lastEnd - 1, amount: item?.amount };
            }
            return undefined;
          })
          ?.filter((el) => el !== undefined);
      });

      executeCalculatorExecute.mutate(creditorSplit, {
        onSuccess: () => {
          message.success("Executed successfully");
          setIsExecuteBtnClicked(false);
          setIsChecked(false);
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  if (!currentLoans) {
    return (
      <div className="flex flex-col p-6 items-center justify-center gap-4">
        <Typography.Text type="danger">Save calculator data first </Typography.Text>
        <Button type="primary" href={`/dashboard/application/${application?.application?.app_key}/calculator`}>
          Go to Calculator
        </Button>
      </div>
    );
  }
  return (
    <Form
      initialValues={getFormInitialValue({ latestPaymentTable, loanIntelligence, savedData, suggestion })}
      // className=" overflow-auto"
      form={form}
      // onFinish={(values) => {
      //   // if (totalRemaining !== 0) {
      //   //   return message.error("Remaining amount must be $0");
      //   // }
      //   // console.log(values);

      //   // console.log(creditorSplit);
      // }}
    >
      <div className="h-[calc(100vh-100px)] overflow-auto">
        <table className={`${styles.main_table}`} style={{ width: "100%" }}>
          <thead>
            <tr>
              <th>Sl.</th>
              <th>Creditor</th>
              <th>Balance Amount</th>
              <th>Original Weekly</th>
              <th>Suggested Weekly</th>
              <th>Start Week</th>
              <th>Final Negotiated</th>
              <th>Action</th>
              {showManual ? (
                <>
                  <th>Remaining</th>
                  {latestPaymentTable?.repeat_rows.map((repeatRow, i) => {
                    return (
                      <th key={i}>
                        Split {i + 1} [{formatMoney(repeatRow?.row?.creditor)} x {repeatRow?.count} weeks]
                      </th>
                    );
                  })}
                </>
              ) : null}
            </tr>
          </thead>
          <tbody>
            {Object.entries(loanIntelligence?.loans?.current ?? {}).map(([loanId, loanInfo], i) => {
              const creditorName = getclearApp?.loans?.find((el) => el?._id === loanId)?.creditor_name;
              const loanIntelligenceLoan = loanIntelligence?.loans?.current?.[loanId];
              const rowTotal = formValues?.[loanId]
                ?.flat()
                ?.reduce((prev, curr) => prev + (curr?.amount ?? 0) * (curr?.weeks ?? 0), 0);

              return (
                <tr key={loanId}>
                  <td>{i + 1}.</td>
                  <td>
                    <div className="inline">
                      <Typography.Text className="mr-1">{creditorName}</Typography.Text>
                      {validateCalculatorExecute?.data ? (
                        <>
                          {loanId in validateCalculatorExecute.data.result.creditor ? (
                            validateCalculatorExecute.data.result.creditor[loanId]?.error ? (
                              <Tooltip
                                title={`Error: ${validateCalculatorExecute.data.result.creditor[loanId]?.error}`}
                              >
                                <TbExclamationCircleFilled className="fill-red-600 inline size-4" />
                              </Tooltip>
                            ) : (
                              <Tooltip
                                title={`Warning: ${validateCalculatorExecute.data.result.creditor[loanId]?.warning}`}
                              >
                                <TbAlertTriangleFilled className="fill-yellow-600 inline size-4" />
                              </Tooltip>
                            )
                          ) : (
                            <Tooltip title={`No problem`}>
                              <TbCircleCheckFilled className="fill-green-600 inline size-4" />
                            </Tooltip>
                          )}
                        </>
                      ) : null}
                    </div>
                  </td>
                  <td className={styles.td_numeric}>{formatMoney(loanIntelligenceLoan?.due_amount, true)}</td>
                  <td className={styles.td_numeric}>
                    {formatMoney(loanIntelligenceLoan?.originalWeeklyPayment, true)}
                  </td>
                  <td className={styles.td_numeric}>
                    {formatMoney(loanIntelligenceLoan?.suggestedWeeklyPayment, true)}
                  </td>
                  <th className={styles.td_numeric}>{loanIntelligenceLoan?.startWeek}</th>
                  <td className={styles.td_numeric}>
                    {formatMoney(loanIntelligenceLoan?.final_negotiated ?? 0, true)}
                  </td>
                  <td>
                    <div className="inline-flex gap-2">
                      {loanIntelligenceLoan?.negotiation_status &&
                      [
                        NegotiationStatus.SUCCESS,
                        NegotiationStatus.MANUAL_ACCEPT,
                        NegotiationStatus.MANUAL_OVERRIDE,
                      ].includes(loanIntelligenceLoan?.negotiation_status) ? (
                        <Button
                          variant="filled"
                          color="primary"
                          loading={autoCalculate?.isPending && autoCalculate?.variables?.creditor_id === loanId}
                          onClick={() => {
                            autoCalculate.mutate(
                              { creditor_id: loanId },
                              {
                                onSuccess: () => {
                                  message.success("Auto calculate successful");
                                  setShowManual(false);
                                  queryClient
                                    .invalidateQueries({
                                      queryKey: ["application/ledger-saved", application?.application?.app_key],
                                    })
                                    .then((data) => {
                                      const initval = getFormInitialValue({
                                        latestPaymentTable,
                                        loanIntelligence,
                                        savedData,
                                        suggestion,
                                      });

                                      form.setFieldsValue(initval);
                                    });
                                },
                                onError: (error) => {
                                  const err = error?.response?.data?.result as {
                                    code?: CalculatorValidationCodes;
                                    message: string;
                                    suggested?: number;
                                  };
                                  const addRowsSuggested = err?.suggested;
                                  if (err?.code === CalculatorValidationCodes.OVERFLOW_TENURE && addRowsSuggested) {
                                    setIsConfirmModalOpen({ state: true, count: addRowsSuggested, loanId: loanId });
                                  }
                                },
                              },
                            );
                          }}
                        >
                          Auto Calculate
                        </Button>
                      ) : null}
                    </div>
                  </td>

                  {showManual ? (
                    <>
                      <td className={styles.td_numeric}>
                        {formatMoney((loanIntelligenceLoan?.due_amount ?? 0) - rowTotal, true)}
                      </td>
                      {latestPaymentTable?.repeat_rows.map((repeatRow, j) => {
                        return (
                          <td key={j} style={{ verticalAlign: "bottom" }}>
                            <SplitCell
                              loanId={loanId}
                              splitIndex={j}
                              form={form}
                              application={application}
                              repeatRow={repeatRow}
                            />
                          </td>
                        );
                      })}
                    </>
                  ) : null}
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={2}>Total</th>
              <th className={styles.td_numeric}>
                {formatMoney(
                  currentLoans.reduce((prev, curr) => prev + (curr?.due_amount ?? 0), 0),
                  true,
                )}
              </th>
              <th className={styles.td_numeric}>
                {formatMoney(
                  currentLoans.reduce((prev, curr) => prev + (curr?.originalWeeklyPayment ?? 0), 0),
                  true,
                )}
              </th>
              <th className={styles.td_numeric}>
                {formatMoney(
                  currentLoans.reduce((prev, curr) => prev + (curr?.suggestedWeeklyPayment ?? 0), 0),
                  true,
                )}
              </th>
              <th></th>
              <th></th>
              <th></th>
              {showManual ? (
                <>
                  <th className={`${styles.td_numeric} ${totalRemaining !== 0 ? "!text-red-600" : ""}`}>
                    {formatMoney(totalRemaining, true)}
                  </th>
                  {latestPaymentTable?.repeat_rows.map((repeatRow, i) => {
                    const currSplitTotal = formValues
                      ? Object.values(formValues)?.reduce(
                          (prev, curr) =>
                            prev +
                            curr?.[i]?.reduce(
                              (inPrev, inCurr) => inPrev + (inCurr?.amount ?? 0) * (inCurr?.weeks ?? 0),
                              0,
                            ),
                          0,
                        )
                      : 0;
                    return <th key={i}>{formatMoney(currSplitTotal)}</th>;
                  })}
                </>
              ) : null}
            </tr>
          </tfoot>
        </table>
      </div>
      <Modal
        open={isConfirmModalOpen.state}
        onCancel={() => {
          setIsConfirmModalOpen({ state: false, count: 0 });
        }}
        {...{
          title: (
            <>
              Do you want to add <b>{isConfirmModalOpen.count}</b> weeks in your tenure?
            </>
          ),
          okButtonProps: {
            loading: modifyNumberOfRows.isPending || autoCalculate.isPending,
          },
          onOk: () => {
            if (!isConfirmModalOpen?.loanId) return;
            modifyNumberOfRows.mutate(
              { application_id: application?.application?._id, count: isConfirmModalOpen.count },
              {
                onSuccess: () => {
                  if (!isConfirmModalOpen?.loanId) return;
                  autoCalculate.mutate(
                    { creditor_id: isConfirmModalOpen?.loanId, force: true },
                    {
                      onSuccess: async () => {
                        message.success("Auto calculate successful");
                        setShowManual(false);
                        // const data =
                        await queryClient.invalidateQueries({
                          queryKey: ["application/ledger-saved", application?.application?.app_key],
                        });

                        // const initval = getFormInitialValue({
                        //   latestPaymentTable,
                        //   loanIntelligence,
                        //   savedData,
                        //   suggestion,
                        // });
                        // console.log("init", data, savedData, initval);

                        // form.setFieldsValue(initval);
                        setIsConfirmModalOpen({ state: false, count: 0 });
                      },
                    },
                  );
                },
              },
            );
          },
        }}
      />
      <div className="flex w-full gap-2 h-[50px] items-center justify-end border-0 border-t border-solid border-gray-200">
        <Button
          // htmlType="submit"
          variant="solid"
          color="blue"
          loading={validateCalculatorExecute.isPending}
          onClick={() => {
            validate();
          }}
        >
          Validate
        </Button>
        <Button
          type="primary"
          loading={saveCalculatorExecute.isPending}
          onClick={() => {
            save();
          }}
        >
          Save
        </Button>
        {isChecked ? (
          <Button
            variant="solid"
            color="green"
            className="mr-4 !bg-green-600"
            loading={executeCalculatorExecute.isPending}
            onClick={() => {
              execute();
            }}
            icon={<TbPlayerPlayFilled />}
          >
            Execute
          </Button>
        ) : (
          <Button
            variant="solid"
            color="green"
            className="mr-4 !bg-green-600"
            loading={executeCalculatorExecute.isPending}
            onClick={() => {
              setIsExecuteBtnClicked(true);
              setPreviewLedgerOpen(true);
            }}
            icon={<TbPlayerPlayFilled />}
          >
            Execute
          </Button>
        )}
      </div>
    </Form>
  );
}

function SplitCell({
  loanId,
  splitIndex,
  form,
  application,
  repeatRow,
}: {
  loanId: string;
  splitIndex: number;
  form: FormInstance<T_FormValues>;
  application: T_QueryData<typeof ApiService.application.useGetByAppKey>;
  repeatRow: {
    row: PaymentEntryTable;
    count: number;
  };
}) {
  const totalCell = Form.useWatch([loanId, splitIndex], form);
  const totalCellAmount = totalCell?.reduce((prev, curr) => prev + (curr?.amount ?? 0) * (curr?.weeks ?? 0), 0);
  const totalCellWeeks = totalCell?.reduce((prev, curr) => prev + (curr?.weeks ?? 0), 0);

  const latestPaymentTable =
    application?.application?.payment_table?.[application?.application?.payment_table?.length - 1];
  const weeks = latestPaymentTable?.repeat_rows[splitIndex]?.count ?? 0;
  const splitAmount = latestPaymentTable?.repeat_rows?.[splitIndex]?.row?.creditor ?? 0;

  const loanIntelligence = application?.application?.loan_intelligence;

  return (
    <Form.List name={[loanId, splitIndex]}>
      {(fields, { add, remove }) => {
        return (
          <div className="flex flex-col gap-2">
            {fields.map(({ key, name, ...restField }) => {
              const currentRowWeek = totalCell ? (totalCell[name]?.weeks ?? 0) : 0;
              const restWeeks = totalCellWeeks - currentRowWeek;
              const maxAllowed = weeks - restWeeks;
              return (
                <div className="inline-flex gap-1 items-center" key={key}>
                  <Form.Item {...restField} name={[name, "amount"]} className="!m-0">
                    <InputNumber
                      style={{ borderRadius: 0 }}
                      placeholder="Amount"
                      prefix="$"
                      min={0}
                      max={splitAmount}
                    />
                  </Form.Item>
                  <TbX className="size-3 flex-shrink-0" />
                  <Form.Item {...restField} name={[name, "weeks"]} className="!m-0">
                    <InputNumber style={{ borderRadius: 0 }} placeholder="Weeks" min={0} max={maxAllowed} />
                  </Form.Item>
                  {key === 0 ? (
                    <div className="size-6">
                      {weeks > totalCellWeeks ? (
                        <Button size="small" shape="circle" icon={<TbPlus />} onClick={() => add()} />
                      ) : null}
                    </div>
                  ) : (
                    <Button size="small" shape="circle" icon={<TbMinus />} onClick={() => remove(name)} />
                  )}
                </div>
              );
            })}
            <div className="bg-gray-50 text-gray-500 font-semibold -mx-2 -mb-2 p-2 border-0 border-t border-solid border-gray-200">
              = {formatMoney(totalCellAmount)}
            </div>
          </div>
        );
      }}
    </Form.List>
  );
}
